<template>
  <div class="root_backgroundContent" ref="rootref">
    <div>
      <div class="top" ref="topref">
        <!-- <span class="hotlabel">热门搜索：</span> -->
        <div class="search-box">
          <LhSearch
            v-model="keyword"
            :hot-cates="hotCates"
            :carousel-visible="true"
            class-name="templates-search-class"
            name="keywords"
            @searchClick="searchClickHandler"
            @cancelClick="cancelClickHandler"
            @historyClick="historyClickHdl"
          ></LhSearch>
        </div>
      </div>
      <!--分类-->
      <div class="category" ref="categoryref">
        <div :class="['cates-wrapper']" :style="{ margin: '20px 0 15px 0' }">
          <div class="direction-radio">
            <span class="title">类型：</span>
            <span
              :class="[sortFileType === '' ? 'active' : '']"
              @click="sortFileTypeChanged('')"
              >全部</span
            >
            <div class="division2"></div>
            <span
              :class="[sortFileType === '25' ? 'active' : '']"
              @click="sortFileTypeChanged('25')"
              >动态背景</span
            >
            <div class="division2"></div>
            <span
              :class="[sortFileType === '1,2' ? 'active' : '']"
              @click="sortFileTypeChanged('1,2')"
              >静态背景</span
            >
          </div>
        </div>
        <cates
          :specialUrl="specialUrl"
          :childName="'场景'"
          :style="{ margin: '0 0 0 5px', minHeight: '20px' }"
          @cateClick="cateClick"
          ref="catesControl"
        ></cates>
        <!--过滤信息-->
        <div :class="['cates-wrapper']" :style="{ margin: '0px 0 0 0' }">
          <div class="direction-radio">
            <span class="title">排序：</span>
            <span
              :class="[sortOrderBy === '' ? 'active' : '']"
              @click="sortOrderByChanged('')"
              >推荐</span
            >
            <!-- <div class="division"></div>
            <span
              :class="[sortOrderBy === '2' ? 'active' : '']"
              @click="sortOrderByChanged('2')"
              >最新</span
            > -->
          </div>
          <div class="direction-radio">
            <span class="title">版式：</span>
            <span
              :class="[direction === '1' ? 'active' : '']"
              @click="changeDirection('1')"
              >横版</span
            >
            <div class="division"></div>
            <span
              :class="[direction === '2' ? 'active' : '']"
              @click="changeDirection('2')"
              >竖版</span
            >
          </div>
          <div class="direction-radio">
            <span class="title">价格：</span>
            <span
              :class="[sortPayType === '' ? 'active' : '']"
              @click="sortPayTypeChanged('')"
              >全部</span
            >
            <div class="division"></div>
            <span
              :class="[sortPayType === '0' ? 'active' : '']"
              @click="sortPayTypeChanged('0')"
              >免费</span
            >
            <div class="division"></div>
            <span
              :class="[sortPayType === '1,2,3' ? 'active' : '']"
              @click="sortPayTypeChanged('1,2,3')"
              >付费</span
            >
            <div class="division"></div>
            <template v-if="IsOldUser">
              <span
                :class="[sortPayType === '4' ? 'active' : '']"
                @click="sortPayTypeChanged('4')"
                >会员专属</span
              >
              <div class="division"></div>
              <span
                :class="[sortPayType === '6' ? 'active' : '']"
                @click="sortPayTypeChanged('6')"
                >企业会员专属</span
              >
            </template>
            <template v-else>
              <span
                :class="[sortPayType === '6' ? 'active' : '']"
                @click="sortPayTypeChanged('6')"
                >{{ getOptionName(6) }}</span
              >
              <div class="division"></div>
              <span
                :class="[sortPayType === '4' ? 'active' : '']"
                @click="sortPayTypeChanged('4')"
                >{{ getOptionName(4) }}</span
              >
            </template>
          </div>
          <div class="direction-radio">
            <span class="title">授权：</span>
            <span
              :class="[sortIsCommerical === '' ? 'active' : '']"
              @click="sortIsCommericalChanged('')"
              >全部</span
            >
            <div class="division"></div>
            <span
              :class="[sortIsCommerical === '1' ? 'active' : '']"
              @click="sortIsCommericalChanged('1')"
              >商用</span
            >
          </div>
          <styleMenu
            class="style-layout"
            v-model="currentStyle"
            :menuList="sortList.style"
            @selectChange="sortStyleChanged"
          ></styleMenu>
          <!-- <div class="sort-style-box">
            <el-select
              v-model="sortStyle"
              placeholder="全部风格"
              popper-class="temp-sort-select"
              @change="sortStyleChanged"
            >
              <el-option
                v-for="item in sortList.style"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>-->
        </div>
      </div>
      <!--列表-->
      <div class="list-div" ref="listdivref" @scroll="loadMore">
        <section class="list">
          <backgroundItem
            :class="['item', '_' + direction]"
            v-for="(item, idx) in srcList"
            :key="idx"
            :direction="direction"
            :bgItem="item"
          ></backgroundItem>
        </section>
        <isEmptyResult v-if="isEmpty"></isEmptyResult>
        <div class="loading">
          <Loading
            :loading="loadingStatus == 1"
            v-show="loadingStatus == 1"
          ></Loading>
          <div v-show="loadingStatus == 2">没有更多内容了哦</div>
        </div>
      </div>
    </div>
    <!--关闭按钮应放在遮罩的下面，否则会引起混乱-->
    <div class="close-lib" @click="closeDialog($event)"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import backgroundItem from "./backgroundItem";
import cates from "../common/cates";
import LhSearch from "../common/search";
import isEmptyResult from "../../isEmptyResult";
import styleMenu from "../../dropDownMenu";
import Loading from "@/components/emodal/templateLib/loading";
import vipBadge from '@/components/mixins/vipBadge';

export default {
  mixins: [vipBadge],
  components: {
    backgroundItem,
    cates,
    LhSearch,
    isEmptyResult,
    styleMenu,
    Loading,
  },
  data() {
    return {
      isEmpty: false,
      direction: "1",
      selectedItem: {},
      srcList: [],
      isLoading: false,
      API: {
        category: "/api/home/category",
        style: "/api/home/style",
        mytemp: "/api/user/template?fPage=6&sOfPage=6",
        hotCate: "/api/common/material/recommendTag",
        temp: "/api/home/template?fPage=19",
        refreshTemp: "/api/common/material?type=8", //&id=temp.checkid
        background: "/api/common/material?type=3&fPage=17",
      },
      cateSelected: { name: "全部" },
      currentStyle: {}, //选中的风格
      keyword: "",
      hotCates: [], //搜索框中的热门标签
      totalFee: "", // 支付价格
      showBuy: { display: "none" }, //显示我的购买
      showFavorite: { display: "none" }, //显示我的收藏
      payvisible: false,
      currentTemplate: {}, //当前点击的模板
      direction: "1", //1横2竖
      sortList: {
        style: [],
      },
      // 0：最新，11：管理后台最优排序
      sortOrderBy: "",
      // payType：付款类型 0免费  1付费  2付费(优惠价) 3付费(折扣) 4企业专属
      sortPayType: "",
      sortStyle: "",
      sortFileType: "",
      sortIsCommerical: "", //1：可商用；0：不可商用
      sOfPage: "8",
      pIndex: 1,
      specialUrl: "/api/home/category?type=3&direction=1",
      listHeight: 535,
      loadingStatus: 0,
    };
  },
  methods: {
    closeDialog(e) {
      this.$store.commit("close_TemplateMaterialLibDialogMsg");
    },
    searchClickHandler(keyword) {
      let query = {};
      if (!this.keyword) return;
      this.cateSelected = { name: "全部" };
      this.loadBackgroundList();
      //console.log("this.keyword => ", this.keyword);
    },
    historyClickHdl(e, keywrod) {
      this.searchClickHandler(keywrod);
    },
    cancelClickHandler() {
      this.cateSelected = { name: "全部" };
      this.sortPayType = "";
      this.sortOrderBy = 11;
      this.loadBackgroundList();
      //console.log("this.keyword => ", this.keyword);
    },
    cateClick(cate) {
      this.keyword = "";
      this.cateSelected = cate;
      this.loadBackgroundList();
      //console.log('this.cateSelected',this.cateSelected)
    },
    sortOrderByChanged(type) {
      this.sortOrderBy = type;
      this.loadBackgroundList();
    },
    sortPayTypeChanged(type) {
      this.sortPayType = type;
      this.loadBackgroundList();
    },
    sortStyleChanged(item) {
      this.sortStyle = item.id;
      this.specialUrl = this.getSpecialUrl(this.sortStyle);
      //console.log("TCL: sortStyleChanged -> this.specialUrl", this.specialUrl);

      this.loadBackgroundList();
    },
    sortFileTypeChanged(type) {
      this.sortFileType = type;
      this.loadBackgroundList();
    },
    sortIsCommericalChanged(type) {
      this.sortIsCommerical = type;
      this.loadBackgroundList();
    },
    //横竖屏模板切换
    changeDirection(d) {
      this.direction = d;
      this.cateSelected = { name: "全部" };
      this.specialUrl = this.getSpecialUrl(this.sortStyle);
      this.loadBackgroundList();
    },
    loadBackgroundList(isLoadMore = false) {
      let url = this.API.background;
      if (!isLoadMore) this.pIndex = 1;
      //拼接请求参数
      if (this.keyword) {
        url += `&keyword=${this.keyword}`;
      }
      if (this.cateSelected.id && this.cateSelected.id !== "x") {
        url += `&category=${this.cateSelected.id}`;
      }
      // if (this.sortStyle) {
      //   url += `&style=${this.sortStyle}`;
      // }
      if (this.sortPayType) {
        url += `&payType=${this.sortPayType}`;
      }
      if (this.sortOrderBy) {
        url += `&orderBy=${this.sortOrderBy}`;
      }
      if (this.direction) url += `&direction=${this.direction}`;
      if (this.sortFileType) url += `&fileType=${this.sortFileType}`;
      if (this.sortIsCommerical)
        url += `&isCommerical=${this.sortIsCommerical}`;

      if (this.sOfPage) {
        url += `&sOfPage=${this.sOfPage}`;
      }
      if (this.pIndex) {
        url += `&pIndex=${this.pIndex}`;
      }
      url += `&draftId=${window.location.hash.slice(2)}`;
      //console.log(window.location.hash);

      let rooth = this.$refs["rootref"].clientHeight;
      let listdiv = this.$refs["listdivref"];
      let listh = listdiv.offsetTop;
      let temph = rooth - listh;
      temph = temph < 10 ? 535 : temph;

      this.loadingStatus = 1;
      // listdiv.style.transition = "height 0.8s";
      // listdiv.style.height = temph - 110 + "px";

      //发送请求
      return this.$http.get(url).then(({ data }) => {
        if (this.keyword) {
          let order_methods = {
            "": "推荐",
            "&orderBy=2": "最新",
          };
          let choose_prices = {
            "": "全部",
            "&payType=0": "免费",
            "&payType=4": "会员专属",
            "&payType=1,2,3": "付费",
            "&payType=6": "企业会员专属"
          };
          sensors.track("classifySearchResult", {
            search_source: "编辑器素材弹窗",
            keyword: this.keyword,
            has_result: !!(data.data && data.data.length),
            material_type: "背景",
            search_type: "素材搜索",
            search_result_num: data.data.length,
            keyword_type: this.trackingData.keyword_type || "手动输入",
            order_method: this.sort ? order_methods[this.sort.value] : "推荐",
            choose_price: this.price ? choose_prices[this.price.value] : "全部",
          });
        }
        //解构data
        if (data.code == 200) {
          if (isLoadMore) data.data.forEach((val) => this.srcList.push(val));
          else this.srcList = data.data;
        } else if (isLoadMore && !data.data.length) this.pIndex--; //失败页码还原
        this.isLoading = false;
        this.isEmpty = !(this.srcList && this.srcList.length > 0);

        this.loadingStatus = 0;
        //listdiv.style.transition = "none";
        listdiv.style.height = temph + "px";
      });
    },
    loadMore(e) {
      //console.log("loadMore() {}");
      //return; //数据测试
      if (this.isLoading) return;
      let scrollTop = e.target.scrollTop;
      let scrollHeight = e.target.scrollHeight;
      let listdiv = this.$refs["listdivref"];
      let contentHeight = listdiv.clientHeight || 0;
      if (scrollTop >= scrollHeight - contentHeight - 5) {
        this.isLoading = true;
        this.pIndex++;
        this.loadBackgroundList(true);
      }
    },
    loadHotCate() {
      //初始化热点
      this.$http.get(this.API.hotCate).then(({ data }) => {
        if (data.code == 200) {
          this.hotCates = data.data;
        }
      });
    },

    getSpecialUrl(style) {
      return (
        `/api/home/category?type=3&direction=${this.direction}`
      );
    },
    activePage(param) {
      //console.log("activePage(param)", param);
      this.currentStyle = this.sortList.style.find(
        (e) => e.id === this.StyleDataMsg.id
      );
      if (param) {
        this.direction = param.optimized === "Horizontal" ? "1" : "2";
        this.$refs.catesControl.selectCateById(param.category);
      }
    },
  },
  computed: {
    ...mapGetters(["StyleArrayMsg", "StyleDataMsg", "WorksProjectId", 'IsOldUser']),
    ...mapGetters({
      trackingData: "tracking/trackingData",
    }),
  },
  mounted() {
    //初始化风格
    if (this.StyleArrayMsg.length > 0) {
      this.sortList.style = this.sortList.style.concat(this.StyleArrayMsg);
      //console.log("this.StyleArrayMsg",this.StyleArrayMsg);
      this.currentStyle = this.sortList.style[0];
      // console.log(
      //   "this.sortList.style[0].value;",
      //   this.sortList.style[0].value
      // );
      //this.sortStyle = this.sortList.style[0].id;
      this.sortStyleChanged(this.sortList.style[0]);
    } else {
      setTimeout(() => {
        // this.sortList.style = this.sortList.style.concat(
        //   this.StyleArrayMsg.map(x => ({ label: x.name, value: x.id + "" }))
        // );
        this.sortList.style = this.sortList.style.concat(this.StyleArrayMsg);
        this.currentStyle = this.sortList.style[0];
        //this.sortStyle = this.sortList.style[0].id;
        this.sortStyleChanged(this.sortList.style[0]);
      }, 3000);
    }

    //初始化热点
    this.$http.get(this.API.hotCate).then(({ data }) => {
      if (data.code == 200) {
        this.hotCates = data.data;
      }
    });
    this.loadBackgroundList();
  },
};
</script>

<style lang="scss" scoped>
.root_backgroundContent {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  border-radius: 0 8px 8px 0;
  overflow: hidden;
  font-size: 12px;
  .top {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    background-color: #f0f0f8;
    width: 100%;
    height: 50px;
    justify-content: flex-end;
    .hotlabel {
      margin-left: 50px;
      margin-right: 230px;
      text-align: left;
      float: right;
      color: #474261;
    }
    .search-box {
      float: right;
      width: 180px;
      height: 32px;
      font-size: 12px;
      margin: 0 56px 0 0;
    }
  }

  .category {
    width: 100%;
    flex-shrink: 0;
    height: auto;
    background-color: white;
    position: relative;
    .cates-wrapper {
      height: 20px;
      position: relative;
      box-sizing: content-box;
      .direction-radio {
        display: -webkit-flex;
        display: flex;
        float: left;
        margin: 0 0 0 40px;
        color: #0a293f;
        //border-right: 1px solid #c4cad1;
        .active {
          //background-color: #5778fb;
          color: #5778fb;
        }
        & > span {
          cursor: pointer;
          transition: all 0.2s ease;
          display: inline-block;
          &.title {
            margin: 0 13px 0 0;
            font-weight: bold;
          }
        }
        .division2 {
          opacity: 0.3;
          margin: 1px 21px 0 21px; //上右下左
          width: 0px;
          border-right: 1px solid #c4cad1;
          height: 16px;
          float: left;
        }
        .division {
          opacity: 0.3;
          margin: 1px 11px 0 11px; //上右下左
          width: 0px;
          border-right: 1px solid #c4cad1;
          height: 16px;
          float: left;
        }
      }
    }
  }
  .style-layout {
    float: left;
    height: 30px;
    margin-left: 39px;
  }
  .list-div {
    position: relative;
    float: left;
    width: 100%;
    height: 550px;
    overflow-y: auto;

    background-color: white;
    //margin: 16px 0 0 0;
    padding: 16px 0 0px 10px;
    .list {
      width: 100%;
      // height: 535px;
      // overflow-y: auto;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding: 0 0 20px 0;
      .item {
        width: 224px;
        margin: 24px 0 0 30px;
        &._1 {
          height: 126px;
        }
        &._2 {
          width: 162px;
          height: 270px;
        }
      }
    }
    .loading {
      margin-bottom: 0px;
      height: 110px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #333333;
      line-height: 110px;
    }
  }

  .preview-subwin {
    position: absolute;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
  }

  .close-lib {
    position: absolute;
    width: 16px;
    height: 16px;
    right: 20px;
    top: 17px;
    background-image: url(../../../../../../static/svg/template-material-lib/common/close-1.svg);
    &:hover {
      background-image: url(../../../../../../static/svg/template-material-lib/common/close-active.svg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/contents/background/backgroundContent.vue